import Swiper, {  Pagination, Autoplay } from 'swiper';
Swiper.use([ Pagination, Autoplay]);


const initSwiper = () => {
  return new Swiper(".projects-sliders", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 1500,
    },
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: 'bullets',
      bulletActiveClass: 'active',
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 30
      },
    }
  });
}
export default initSwiper;
